module.exports = __webpack_public_path__ + "img/charter-logo.a000ef5d.png";